export default function isCorrectInn(inn){
    const containsTwelveDigits = (str) => /^\d{12}$/.test(str);
    if(!containsTwelveDigits(inn)) return {err:true,message:'ИНН не должен содержать только 12 цифр'}
    return {err:false,message:'ИНН корректен'}
}